// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single_video {
  position: relative;
}
.single_video .single_video_section {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
}
.single_video .single_video_section::before {
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  background: hsla(180, 4%, 5%, 0.6);
}
.single_video .single_video_section .description p {
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/bookmarks/bookmark_videos/bookmark_singlevideo/_singlevideo.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAEI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,6BAAA;AAAR;AAEQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,kCAAA;AAAZ;AAEQ;EACI,cAAA;AAAZ","sourcesContent":[".single_video {\n    position: relative;\n\n\n    .single_video_section {\n        position: relative;\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-around;\n\n        &::before {\n            content: '';\n            width: 100%;\n            height: 100%;\n            left: 0;\n            top: 0;\n            position: absolute;\n            background: hsla(180, 4%, 5%, 0.6);\n        }\n        .description p {\n            color: #ffffff;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
